export class RegionsModel {
    constructor(
        public id : any ,
        public corp : string,
        public area : string ,
        public region : string ,
        public majorarea : string ,
        public created_dt : Date ,
        public created_by : string ,
        public updated_dt : Date ,
        public updated_by : string,
        public regionsList: string[],
        public areasList: string[],
        public corpsList: string[],
        public status: string,
        public comment: string
    ){}
}
